import { Injectable } from '@angular/core';
import { BaseLocationExtendedInterface } from '../_interfaces/base-location-extended.interface';
import { DepartmentListItemResponse, LocationListItemResponse } from '../../../../api';

@Injectable({ providedIn: 'root' })
export class BaseLocationsDataService {
  prepareLocationsData(
    locations: LocationListItemResponse[],
    departments: DepartmentListItemResponse[]
  ): BaseLocationExtendedInterface[] {
    return locations.map((location) => {
      let filteredDepartments = departments.filter((dept) => dept.location.id === location.id);

      return {
        ...location,
        departments: filteredDepartments,
      } as BaseLocationExtendedInterface;
    });
  }
}
